jQuery(document).ready(function($){
	var elems = document.querySelectorAll('.splide.slider:not([data-splide-ignore])');

	if (elems.length) {
		elems.forEach(function (elem) {
			let slider = new Splide(elem, {
				type: 'loop',
				perPage: 1,
				gap: '2rem',
				arrows: {
                    prev: '.splide__arrow--prev',
                    next: '.splide__arrow--next',
                },
				pagination: true,
				trimSpace: true,
				arrows: true,
				arrowPath: 'm14.2928932 10.2928932c.3905243-.39052427 1.0236893-.39052427 1.4142136 0l9 9 .7071068.7071068-9.7071068 9.7071068c-.3905243.3905243-1.0236893.3905243-1.4142136 0s-.3905243-1.0236893 0-1.4142136l8.2921068-8.2928932-8.2921068-8.2928932c-.3604839-.360484-.3882135-.927715-.0831886-1.3200062z',
				classes: {
					arrows: 'splide__arrows',
					arrow: 'splide__arrow',
					prev: 'splide__arrow--prev',
					next: 'splide__arrow--next',
					pagination: 'splide__pagination',
					page: 'splide__pagination__page',
				},
				breakpoints: {
					1024: {
						gap: '1.5rem',
					}
				}
			});

            slider.on('pagination:mounted', function(data) {
                
            });
            
            slider.mount();
		});
	}

});